/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import get from "lodash/get";
// Utility functions for inserting ads in story based on Pagebuilder config

export const addSlotsToStory = (storyCards, slots) => {
  for (const slotNumber of Object.keys(slots)) {
    const slotConfig = slots[slotNumber];
    let numberOfElements = get(storyCards, [slotNumber - 1, "story-elements", "length"], 0);
    if (numberOfElements === 0) continue;
    if (slotConfig.before) {
      storyCards[slotNumber - 1]["story-elements"].splice(0, 0, ...slotConfig.before);
    }
    // numberOfElements might change if a new slot is added
    numberOfElements = get(storyCards, [slotNumber - 1, "story-elements", "length"], 0);
    if (slotConfig.after) {
      storyCards[slotNumber - 1]["story-elements"].splice(numberOfElements, 0, ...slotConfig.after);
    }
  }
  return storyCards;
};
